import {
  checkAssetsValidEn,
  checkAssetsValidTh,
} from '@Containers/UploadImageFormFields/utils';
import { BusinessValueChainFormValues } from '../ImpactsOnStakeholdersFormProvider/types';
import {
  checkEditorMessageEn,
  checkMessageEn,
  validateSpace,
  validateSpaceTextInput,
} from '@Utils/validation';

export const checkBizValueCompletionTh = (
  businessValueChain?: BusinessValueChainFormValues
) => {
  if (!businessValueChain) return false;

  const { descriptionTh } = businessValueChain;

  if (!descriptionTh) return false;

  return validateSpace(descriptionTh);
};

export const checkBizValueCompletionEn = (
  businessValueChain?: BusinessValueChainFormValues
): boolean => {
  if (!businessValueChain) return false;

  const { descriptionEn } = businessValueChain;

  if (!descriptionEn) return false;

  return validateSpace(descriptionEn) && checkEditorMessageEn(descriptionEn);
};

export const checkBizRemarkEnValid = (
  businessValueChain?: BusinessValueChainFormValues
): boolean =>
  !businessValueChain?.remark?.descriptionEn ||
  (validateSpaceTextInput(businessValueChain?.remark?.descriptionEn) &&
    checkMessageEn(businessValueChain?.remark?.descriptionEn));

export const checkBizIntroductionEnValid = (
  businessValueChain?: BusinessValueChainFormValues
): boolean =>
  !businessValueChain?.introduction?.descriptionEn ||
  (validateSpace(businessValueChain?.introduction?.descriptionEn) &&
    checkEditorMessageEn(businessValueChain?.introduction?.descriptionEn));

export const checkBizRemarkThValid = (
  businessValueChain?: BusinessValueChainFormValues
): boolean =>
  !businessValueChain?.remark?.descriptionTh ||
  validateSpaceTextInput(businessValueChain?.remark?.descriptionTh);

export const checkBizIntroductionThValid = (
  businessValueChain?: BusinessValueChainFormValues
): boolean =>
  !businessValueChain?.introduction?.descriptionTh ||
  validateSpace(businessValueChain?.introduction?.descriptionTh);

export const checkBizAssetsValidTh = (
  businessValueChain?: BusinessValueChainFormValues
) => checkAssetsValidTh(businessValueChain);

export const checkBizAssetsValidEn = (
  businessValueChain?: BusinessValueChainFormValues
) => checkAssetsValidEn(businessValueChain);
